
const Main = () => import('@/views/main');
const changeCode = () => import('@/views/change-code/index');
const detailCode = () => import('@/views/change-code/detail-code');
const addCode = () => import('@/views/change-code/add-code');
const couponIndex = () => import('@/views/change-code/coupon-index');
const newCoupon = () => import('@/views/change-code/coupon-new');
const couponShow = () => import('@/views/change-code/coupon-show');
const activeIndex = () => import('@/views/change-code/active-index');
const newActive = () => import('@/views/change-code/active-new');
const giftManageIndex = () => import('@/views/change-code/gift-manage-index');
const giveActiveSellDetail = () => import('@/views/change-code/give-active-sell-detail');
const sendBatchCoupon = () => import('@/views/change-code/coupon-send');

const platformSell = () => import('@/views/change-code/platform-sell');
const addSell = () => import('@/views/change-code/add-sell');

const exchangeGift = () => import('@/views/change-code/exchange-gift');
const exchangeGiftAdd = () => import('@/views/change-code/exchange-gift-add');
const companyOrder = () => import('@/views/change-code/company-order');
const companyOrderCreate = () => import('@/views/change-code/company-order-create');
const companyOrderDetail = () => import('@/views/change-code/company-order-detail');
const exchangeGiftDetail = () => import('@/views/change-code/exchange-gift-detail');
const exchangeGroupDetail = () => import('@/views/order/exchange-group-order-detail');
const recommender = () => import('@/views/operation/recommender');

export default [{
    path: '/changeCode',
    name: 'changeCode',
	redirect: {
		name: 'couponIndex'
	},
    component: Main,
    meta: {
        hide: false,
        name: '营销管理',
        unfold: true,
        iconType: '14'
    },
    children: [
		{
			path: 'couponIndex',
			name: 'couponIndex',
			component: couponIndex,
			meta: {
				name: '优惠券管理 '
			},
			children: [
				{
					path: "newCoupon",
					component: newCoupon,
					name: "newCoupon",
					meta: {
						name: '新增优惠券'
					},
				},
				{
					path: "newCouponEdit",
					component: newCoupon,
					name: "newCouponEdit",
					meta: {
						name: '编辑优惠券'
					},
				},
				{
					path: "newCouponDetail",
					component: newCoupon,
					name: "newCouponDetail",
					meta: {
						name: '优惠券详情'
					},
				},
				{
					path: "couponShow",
					component: couponShow,
					name: "couponShow",
					meta: {
						name: '领取用户查看'
					},
				},
			]
		},
		{
			path: "sendBatchCoupon",
			component: sendBatchCoupon,
			name: "sendBatchCoupon",
			meta: {
				name: '发放优惠券'
			},
		},
		{
			path: "giftManageIndex",
			component: giftManageIndex,
			name: "giftManageIndex",
			meta: {
				name: "商品购买赠送管理"
			},
			children:[
				{
					path: "giveActiveSellDetail/:id",
					component: giveActiveSellDetail,
					name: "giveActiveSellDetail",
					meta: {
						name: '售卖明细'
					},
				}
			]
		},
		{
			path: "platformSell",
			component: platformSell,
			name: "platformSell",
			meta: {
				name: "收银台优惠管理"
			},
			children:[
				{
					path: "addSell",
					component: addSell,
					name: "addSell",
					meta: {
						name: '新增票券优惠'
					},
				},
				{
					path: "editSell",
					component: addSell,
					name: "editSell",
					meta: {
						name: '编辑票券优惠'
					},
				},
				{
					path: "detailSell",
					component: addSell,
					name: "detailSell",
					meta: {
						name: '票券优惠详情'
					},
				},
				{
					path: "addRetail",
					component: addSell,
					name: "addRetail",
					meta: {
						name: '新增零售优惠'
					},
				},
				{
					path: "editRetail",
					component: addSell,
					name: "editRetail",
					meta: {
						name: '编辑零售优惠'
					},
				},
				{
					path: "detailRetail",
					component: addSell,
					name: "detailRetail",
					meta: {
						name: '零售优惠详情'
					},
				},
			]
		},
		{
			path: "exchangeGift",
			component: exchangeGift,
			name: "exchangeGift",
			meta: {
				name: "兑换礼券管理"
			},
			children:[
				{
					path: "exchangeGiftAdd",
					component: exchangeGiftAdd,
					name: "exchangeGiftAdd",
					meta: {
						name: '新增兑换礼券'
					},
				},
				{
					path: "exchangeGiftEdit",
					component: exchangeGiftAdd,
					name: "exchangeGiftEdit",
					meta: {
						name: '编辑兑换礼券'
					},
				},
				{
					path: "exchangeGiftDetail",
					component: exchangeGiftDetail,
					name: "exchangeGiftDetail",
					meta: {
						name: '兑换活动详情'
					},
				},
			]
		},
		{
			path: 'companyGroup',
			name: 'companyGroup',
			component: companyOrder,
			meta: {
				name: '企业团购管理 '
			},
			children: [{
					path: 'companyOrderCreate',
					name: 'companyOrderCreate',
					component: companyOrderCreate,
					meta: {
						name: '创建销售订单'
					},
				},
				{
					path: 'companyOrderDetail',
					name: 'companyOrderDetail',
					component: companyOrderDetail,
					meta: {
						name: '兑换商品详情'
					},
				},
				{
					path: "exchangeGroupDetail",
					name: "exchangeGroupDetail",
					component: exchangeGroupDetail,
					hide: true,
					unfold: false,
					meta: {
						name: "团购销售订单详情"
					}
				},
			]
		},
        {
            path: 'recommendIndex',
            name: 'recommendIndex',
            component: recommender,
            meta: {
                name: '推荐码管理'
            },
        },
    ]
}]

